import { ConfiguratorOptions } from './configurator-options';
import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class PageComponent {
    public abstract title: string | ((options?: ConfiguratorOptions) => string);
    public options: {
        title: string | Observable<string>;
        component?: Type<any>;
        componentData?: any;
        callback?: () => void;
        icon?: {
            fontSet?: string,
            fontIcon?: string,
            ligature?: string
        };
        show?: () => boolean
    }[] = [];
    public fullscreen = false;
    public isSummaryHidden = false;
    public isStepperHidden = false;
    public forceReturnButton = false;
    public stepId = '';
    constructor() {}
}
